export default "__VITE_ASSET__3bf23a70__"